// Module
var code = "<div class=\"cross\"> <span class=\"cross_line\"></span> <span class=\"cross_line\"></span> </div> ";
// Exports
export default code;